import { createContext, useContext } from "react"

const RenderContext = createContext({ mode: "editing", target: "email" })

export const useRenderContext = () => {
  return useContext(RenderContext)
}

export default RenderContext
